import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

export default {
  id: 'MOD_INVIT_CLT',
  title: 'Un modello di Invito al Cliente?',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Se si desidera procedere con gli inviti dei clienti in massa, si prega di prendere il seguente modello:'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: `${pathHelpContentFile}it/IT_MOD_INVIT_CLT/Contacts Clients.xls.xlsx`,
    label: 'Invito al Cliente'
  }]
};
